import { useTranslation } from 'react-i18next';

const TONE = {
  AWAITING_APPROVAL: 'amber',
  PENDING: 'blue',
  CONFIRMED: 'blue',
  IN_PROGRESS: 'blue',
  COMPLETED: 'green',
  CANCELLED: 'gray',
  REJECTED: 'red',
  ACTIVE: 'green',
  SUSPENDED: 'red',
  INACTIVE: 'gray',
};

const ACCOUNT_LABEL_FR = { ACTIVE: 'Actif', SUSPENDED: 'Suspendu', INACTIVE: 'Inactif', PENDING: 'En attente', REJECTED: 'Rejeté' };
const ACCOUNT_LABEL_EN = { ACTIVE: 'Active', SUSPENDED: 'Suspended', INACTIVE: 'Inactive', PENDING: 'Pending', REJECTED: 'Rejected' };

export default function StatusBadge({ status, kind = 'booking' }) {
  const { t, i18n } = useTranslation();
  const tone = TONE[status] || 'gray';
  let label = status;
  if (kind === 'account') {
    label = (i18n.language?.startsWith('en') ? ACCOUNT_LABEL_EN : ACCOUNT_LABEL_FR)[status] || status;
  } else {
    label = t(`booking.status.${status}`, { defaultValue: status });
  }
  return <span className={`badge ${tone}`}>{label}</span>;
}
